import cx from 'clsx';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const SensorListTableBodySkeleton = () => {
  return (
    <div className={style.sensorListTableBody}>
      {[...Array(7)].map(() => (
        <div
          key={uuidv4()}
          className={cx(style.sensorListTableBodyRow, style.sensorListTableBodyRowSkeleton)}
        >
          <div className={style.sensorListTableBodyName}>
            <SkeletonBlock className={style.skeletonText} />
          </div>
          <div className={style.sensorListTableBodyCode}>
            <SkeletonBlock className={style.skeletonText} />
          </div>
          <div className={style.sensorListTableBodyStatus}>
            <SkeletonBlock className={style.skeletonText} />
          </div>
          <div className={style.sensorListTableBodyLinks}>
            <SkeletonBlock className={style.skeletonText} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default SensorListTableBodySkeleton;
